// Desktop mega menu (snippets/site-mega-nav.liquid).
// Hover intent: the first panel opens almost at once, but another top item only takes over after the
// pointer rests on it (SWITCH_DELAY) and is still there, so moving diagonally toward the far side of an
// open panel never opens the items it passes over. Panels also wait CLOSE_DELAY before closing, to
// bridge the gap between the nav row and the panel. Keyboard focus opens panels through CSS
// (:has(:focus-visible)), so a mouse click inside a panel never holds it open.
const OPEN_DELAY = 80;
const SWITCH_DELAY = 300;
const CLOSE_DELAY = 250;

class SiteMegaNav extends HTMLElement {
  connectedCallback() {
    this.items = [...this.querySelectorAll('.mega-nav__item--has-panel')];
    this.open = null;
    this.over = null;
    this.timer = null;

    this.items.forEach((item) => {
      const trigger = item.querySelector(':scope > .mega-nav__link');
      item.addEventListener('mouseenter', () => {
        this.over = item;
        const delay = this.open && this.open !== item ? SWITCH_DELAY : OPEN_DELAY;
        // Only switch if the pointer is still on this item when the pause ends
        this.schedule(() => this.over === item && this.show(item), this.open === item ? 0 : delay);
      });
      item.addEventListener('mouseleave', () => {
        if (this.over === item) this.over = null;
        this.schedule(() => this.show(null), CLOSE_DELAY);
      });
      item.addEventListener('focusin', () => trigger.setAttribute('aria-expanded', 'true'));
      item.addEventListener('focusout', (e) => {
        if (!item.contains(e.relatedTarget)) trigger.setAttribute('aria-expanded', String(item === this.open));
      });
      item.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        this.show(null);
        item.classList.add('is-dismissed');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus();
      });
      trigger.addEventListener('blur', () => item.classList.remove('is-dismissed'));
    });

    // Plain top items (no panel) close any open panel after the same pause
    this.querySelectorAll('.mega-nav__item:not(.mega-nav__item--has-panel)').forEach((item) => {
      item.addEventListener('mouseenter', () => this.schedule(() => this.show(null), SWITCH_DELAY));
    });

    this.querySelectorAll('[data-mega-target]').forEach((link) => {
      const show = () => {
        const panel = link.closest('.mega-nav__panel');
        panel.querySelectorAll('[data-mega-target]').forEach((l) => l.classList.toggle('is-active', l === link));
        panel.querySelectorAll('.mega-nav__group').forEach((g) => g.classList.toggle('is-active', g.id === link.dataset.megaTarget));
      };
      link.addEventListener('mouseenter', show);
      link.addEventListener('focus', show);
    });
  }

  schedule(fn, delay) {
    clearTimeout(this.timer);
    this.timer = delay ? setTimeout(fn, delay) : (fn(), null);
  }

  show(item) {
    this.open = item;
    this.items.forEach((i) => {
      const isOpen = i === item;
      i.classList.toggle('is-open', isOpen);
      if (!isOpen) i.classList.remove('is-dismissed');
      i.querySelector(':scope > .mega-nav__link').setAttribute('aria-expanded', String(isOpen));
    });
  }
}

if (!customElements.get('site-mega-nav')) customElements.define('site-mega-nav', SiteMegaNav);
